import { Component, Input, OnInit } from '@angular/core';
import { TagList } from '../../tags/tag-list';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss'],
    standalone: false
})
export class TagsComponent implements OnInit {
  @Input() items: TagList[] = [];
  translations: any;

  private readonly tagTranslationKeys: Record<string, string> = {
    'Situations, Relationships & Problems': 'tagSituationsText',
    'Thoughts': 'tagThoughtsText',
    'Emotions': 'tagEmotionsText',
    'Physical Feelings': 'tagPhysicalFeelingsText',
    'Behaviours': 'tagBehavioursText',
  };

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
  }

  getTagLabel(tagName: string): string {
    const key = this.tagTranslationKeys[tagName];
    return (key && this.translations?.[key]) || tagName;
  }
}
